import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
// import { useDispatch } from "react-redux";
// import { logout } from "../Redux/AuthSlice/AuthReducer";
const useIdleTimeout = ({ onIdle, idleTime = 1, disabled = false }) => {


  const idleTimeout = 60000 * idleTime; // pehly 1000 tha
  const [isIdle, setIdle] = useState(false);
  // const dispatch = useDispatch();

  const handleIdle = () => {
    setIdle(true);
    window.location.reload();
  };
  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    promptBeforeIdle: idleTimeout / 2,
    onPrompt: onIdle,
    // onIdle: handleIdle, // agr ap chaty ho k popup any k bad kuch minutes bad khud hi log out ho jaye
    debounce: 500,
    disabled
  });
  return {
    isIdle,
    setIdle,
    idleTimer,
  };
};
export default useIdleTimeout;
